import React from 'react';
import { Link } from 'react-router-dom';


const Earth = () => {
	return (
<>
<p><Link to="/">Home</Link></p>
<h1>Earth</h1>
<img alt="Planet Earth Mythology" src="https://upload.wikimedia.org/wikipedia/commons/9/97/The_Earth_seen_from_Apollo_17.jpg" style={{"width":"200px","margin-top":"10px"}}/>
		
<p className="godLink"><a href="https://en.wikipedia.org/wiki/Gaia" >Gaia - Greek</a></p>
<p className="godDescription">Ancestral mother</p>

<p className="godLink"><a href="https://en.wikipedia.org/wiki/Terra" >Terra - Roman</a></p>
<p className="godDescription">regularly associated with <a href="https://en.wikipedia.org/wiki/Ceres_(mythology)">Ceres</a> in rituals pertaining to the earth and agricultural fertility. The cornucopia, or bunches of flowers or fruit. She was typically depicted reclining, or rising, waist high, from a hole in the ground.</p>

<hr/>
<p>See also:</p>
<p><a href="https://en.wikipedia.org/wiki/Category:Agricultural_deities
">Agricultural Deities</a></p>
<p><a href="https://en.wikipedia.org/wiki/List_of_nature_deities
">Nature Deities</a></p>
<p><a href="https://en.wikipedia.org/wiki/List_of_tree_deities
">Tree Deities</a></p>



		</>
		);
}

export default Earth;